import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { designerPaths } from '../../../designer.paths';
import { DsgTranslatePipe } from '../../../pipes/translate.pipe';

import { LogoSoloComponent } from '../../../root/sidenav/logo-solo/logo-solo.component';
import { PageBaseDirective } from '../../../shared-components/page-base.directive';

@Component({
  selector: 'ss-unauthorized',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    LogoSoloComponent,
    MatButtonModule,
    MatIconModule,
    DsgTranslatePipe
  ],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css'],
  host: {
    class: 'full-stretch background-lightgray'
  },
  hostDirectives: [PageBaseDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedComponent {


  constructor(
    private readonly _router: Router
  ) {


  }

  navigateAway() {
    this._router.navigate([designerPaths.processOverview])
  }
}
